var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subnav"},_vm._l((_vm.routeList),function(item){return (item.right)?_c('router-link',{key:item.route,staticClass:"link",attrs:{"to":{ name: item.route, params: { project_id: _vm.projectId } }}},[_vm._v(_vm._s(item.name)+"\n  ")]):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }